export enum OnCallTypes {
  SETSPECIALISTSTATUS = '@onCall/SETSPECIALISTSTATUS',
  STOP_ONCALL = '@onCall/STOP_ONCALL',
  STOP_ONCALL_SUCCESS = '@onCall/STOP_ONCALL_SUCCESS',
  STOP_ONCALL_FAILED = '@onCall/STOP_ONCALL_FAILED',
}
